import { IMerchantDto } from "./MerchantDto";

export interface IMerchantsDto {
  merchants: IMerchantDto[] | [] | null;
}

export class MerchantsDto implements IMerchantsDto {
  public merchants: IMerchantDto[];
  constructor(merchants: Array<IMerchantDto> = new Array<IMerchantDto>()) {
    this.merchants = merchants;
  }
}